import React from 'react';
import {clsx} from "clsx";
import {CheckIcon, XMarkIcon} from "@heroicons/react/24/outline";

export const StatusColor = {
	default: 'bg-gray-100 text-gray-600 border-gray-100',
	pending: 'bg-orange-50 text-orange-600 border-orange-50',
	completed: 'bg-green-50 text-green-600 border-green-50',
	paid: 'bg-green-50 text-green-600 border-green-50',
	failed: 'bg-rose-500 text-white border-rose-50',
	expired: 'bg-orange-300 text-rose-600 border-rose-50',
	refunded: 'bg-teal-50 text-teal-600 border-teal-50',
	approved_external: 'bg-indigo-50 text-indigo-600 border-indigo-50',
	canceled: 'bg-rose-50 text-rose-600 border-rose-50',
	on_hold: 'bg-rose-600 text-white border-rose-600',
	blocked: 'bg-rose-600 text-white border-rose-600',
	'in progress': 'bg-cyan-50 text-[#0b6a8c] border-cyan-50',
	
	active: 'bg-green-50 text-green-600 border-green-50',
	inactive: 'bg-rose-50 text-rose-600 border-rose-50',
	
	accepted: 'bg-green-50 text-green-600 border-green-50',
	rejected: 'bg-rose-50 text-rose-600 border-rose-50',
	
	Yes: 'bg-green-50 text-green-600 border-green-50',
	No: 'bg-rose-50 text-rose-600 border-rose-50',
	
	not_found: 'bg-rose-50 text-rose-600 border-rose-50',
	unknown_error: 'bg-rose-50 text-rose-600 border-rose-50',
}

function StatusBadge({status, boolean, w, h, className}) {
	const statusClass = StatusColor[status] || StatusColor.default;
	
	const width = !!w ? w : 'w-4';
	const height = !!h ? h : 'h-4';
	
	if (boolean) {
		return (
			<div className={clsx(
				status ? "border border-1 border-cyan-300 text-cyan-400" : "border border-1 border-red-300 text-red-400",
				"inline-flex items-center p-0.5 rounded-full font-semibold uppercase border")}>
				{status && <CheckIcon className={clsx(width, height, "flex-shrink-0 self-center")} aria-hidden="true"/>}
				{!status && <XMarkIcon className={clsx(width, height, "flex-shrink-0 self-center")} aria-hidden="true"/>}
			</div>
		);
	}
	
	return (
		<span className={clsx(statusClass, "inline-flex items-center rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase border", className)}>{status}</span>
	);
}

export default StatusBadge;